import React, {useContext} from 'react';

import { Button, Dropdown, Input, Modal } from 'semantic-ui-react';
import { GlobalContext } from '../contexts/GlobalContext';


const MessageModal = (props) => {

    const [state, setState] = useContext(GlobalContext);


    const addPosition = () => {

        // if (name.trim() === '') {
        //     // display error, must fill out field
        // }

        // else {
        //     console.log('Position Added');
        //     props.onClose();

        //     firebase.firestore().collection('positions').add( {
        //         name: name,
        //         qualifications: qualifications,
        //         timeslot: timeslot
        //     }).then(() => {

        //         props.refreshListCb();

        //     }).catch(err => {
        //         console.log(err);
        //     });
        // }
    }
    
    return (
        <div>

            <Modal dimmer='blurring' open={props.show}
            >
            <Modal.Header>{state['messageModal'] ? state['messageModal'].header : ''}</Modal.Header>
            <Modal.Content>
                <p>{state['messageModal'] ? state['messageModal'].message : ''}</p>
            </Modal.Content>
            <Modal.Actions>
                <Button positive onClick={props.onClose} >
                OK
                </Button>
            </Modal.Actions>
            </Modal>
        </div>
    );
};

export default MessageModal;